<template>
    <base-button
        :disabled="disabled"
        :class="[
            appliedVariant,
            'rounded-full text-[14px] lg:text-[16px]',
            'focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2',
            {
                'opacity-50 hover:opacity-50': disabled || variant === 'primaryDisabled',
                'hover:bg-red hover:text-white': !disabled && variant !== 'primaryDisabled',
            },
        ]"
    >
        <slot />
    </base-button>
</template>

<script>
    import BaseButton from './BaseButton.vue';

    export default {
        components: {
            BaseButton,
        },

        props: {
            variant: {
                type: String,
                default: 'primary',
            },

            disabled: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                variants: {
                    primary: 'bg-white border-2 border-red text-red',
                    primaryDisabled: 'bg-white border-2 border-red text-red',
                    secondary: 'border border-gray bg-white',
                },
            };
        },

        computed: {
            appliedVariant() {
                return this.variant === 'primary' && this.disabled === true ? this.variants.primaryDisabled : this.variants[this.variant];
            },
        },
    };
</script>
